import { render, staticRenderFns } from "./eduMineList.vue?vue&type=template&id=b453be60&scoped=true"
import script from "./eduMineList.vue?vue&type=script&lang=js"
export * from "./eduMineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b453be60",
  null
  
)

export default component.exports